<div class="row">
  <h2>{{ '::HomeBanners' | abpLocalization }}</h2>
  <hr />

  <div *ngIf="isLoading" class="text-center py-4">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
  </div>

  <form *ngIf="!isLoading" [formGroup]="form" (ngSubmit)="save()">
    <div class="row">
      <div class="col-12 col-lg-4 mb-4">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <strong>{{ '::HomeBanner1' | abpLocalization }}</strong>
            <div class="form-check form-switch mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                id="banner1IsEnabled"
                formControlName="banner1IsEnabled"
              />
              <label class="form-check-label" for="banner1IsEnabled">
                {{ '::HomeBannerEnabled' | abpLocalization }}
              </label>
            </div>
          </div>
          <div class="card-body">
            <div class="banner-preview mb-3" *ngIf="bannerPreviews['banner1']">
              <img [src]="bannerPreviews['banner1']" alt="Banner 1 preview" class="banner-preview-image" />
              <button type="button" class="btn btn-sm btn-outline-danger mt-2 w-100" (click)="clearImage('banner1')">
                <i class="fa fa-trash me-1"></i>{{ '::Delete' | abpLocalization }}
              </button>
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner1File">
                {{ '::HomeBannerImage' | abpLocalization }}
              </label>
              <input
                type="file"
                id="banner1File"
                class="form-control"
                accept="image/*"
                (change)="onFileChanged($event, 'banner1')"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner1Url">
                {{ '::HomeBannerUrl' | abpLocalization }}
              </label>
              <input
                type="text"
                id="banner1Url"
                class="form-control"
                formControlName="banner1Url"
                placeholder="https://"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner1Description">
                {{ '::HomeBannerDescription' | abpLocalization }}
              </label>
              <textarea
                id="banner1Description"
                class="form-control"
                formControlName="banner1Description"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4 mb-4">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <strong>{{ '::HomeBanner2' | abpLocalization }}</strong>
            <div class="form-check form-switch mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                id="banner2IsEnabled"
                formControlName="banner2IsEnabled"
              />
              <label class="form-check-label" for="banner2IsEnabled">
                {{ '::HomeBannerEnabled' | abpLocalization }}
              </label>
            </div>
          </div>
          <div class="card-body">
            <div class="banner-preview mb-3" *ngIf="bannerPreviews['banner2']">
              <img [src]="bannerPreviews['banner2']" alt="Banner 2 preview" class="banner-preview-image" />
              <button type="button" class="btn btn-sm btn-outline-danger mt-2 w-100" (click)="clearImage('banner2')">
                <i class="fa fa-trash me-1"></i>{{ '::Delete' | abpLocalization }}
              </button>
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner2File">
                {{ '::HomeBannerImage' | abpLocalization }}
              </label>
              <input
                type="file"
                id="banner2File"
                class="form-control"
                accept="image/*"
                (change)="onFileChanged($event, 'banner2')"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner2Url">
                {{ '::HomeBannerUrl' | abpLocalization }}
              </label>
              <input
                type="text"
                id="banner2Url"
                class="form-control"
                formControlName="banner2Url"
                placeholder="https://"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner2Description">
                {{ '::HomeBannerDescription' | abpLocalization }}
              </label>
              <textarea
                id="banner2Description"
                class="form-control"
                formControlName="banner2Description"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4 mb-4">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <strong>{{ '::HomeBanner3' | abpLocalization }}</strong>
            <div class="form-check form-switch mb-0">
              <input
                class="form-check-input"
                type="checkbox"
                id="banner3IsEnabled"
                formControlName="banner3IsEnabled"
              />
              <label class="form-check-label" for="banner3IsEnabled">
                {{ '::HomeBannerEnabled' | abpLocalization }}
              </label>
            </div>
          </div>
          <div class="card-body">
            <div class="banner-preview mb-3" *ngIf="bannerPreviews['banner3']">
              <img [src]="bannerPreviews['banner3']" alt="Banner 3 preview" class="banner-preview-image" />
              <button type="button" class="btn btn-sm btn-outline-danger mt-2 w-100" (click)="clearImage('banner3')">
                <i class="fa fa-trash me-1"></i>{{ '::Delete' | abpLocalization }}
              </button>
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner3File">
                {{ '::HomeBannerImage' | abpLocalization }}
              </label>
              <input
                type="file"
                id="banner3File"
                class="form-control"
                accept="image/*"
                (change)="onFileChanged($event, 'banner3')"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner3Url">
                {{ '::HomeBannerUrl' | abpLocalization }}
              </label>
              <input
                type="text"
                id="banner3Url"
                class="form-control"
                formControlName="banner3Url"
                placeholder="https://"
              />
            </div>
            <div class="mb-3">
              <label class="form-label" for="banner3Description">
                {{ '::HomeBannerDescription' | abpLocalization }}
              </label>
              <textarea
                id="banner3Description"
                class="form-control"
                formControlName="banner3Description"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

    </div>

    <abp-button (click)="save()" [disabled]="isSaving">
      <i class="fa fa-save me-1"></i>
      <i *ngIf="isSaving" class="fa fa-spinner fa-spin me-1"></i>
      {{ '::Save' | abpLocalization }}
    </abp-button>
  </form>
</div>
